import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ef0cd34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-item" }
const _hoisted_2 = { class: "flex grow justify-between align-center" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "100",
  src: "ico/store2.svg"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeInput = _resolveComponent("SeInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.shopItem.getName()), 1)
      ]),
      _createVNode(_component_ToggleSwitch, {
        defaultValue: _ctx.shopItem.getActive(),
        modelValue: _ctx.shopItem.active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shopItem.active) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Actif")
        ]),
        _: 1
      }, 8, ["defaultValue", "modelValue"])
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = () => _ctx.pickIllustration(_ctx.shopItem)),
      class: "flex align-center justify-center p12 shop-illustration"
    }, [
      _withDirectives(_createElementVNode("img", {
        style: {"border-radius":"12px"},
        height: "150",
        ref: "illustration",
        src: _ctx.shopItem.getIllustration()!
      }, null, 8, _hoisted_4), [
        [_vShow, _ctx.hasIllustration]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_7, 512), [
        [_vShow, !_ctx.hasIllustration]
      ])
    ]),
    _createVNode(_component_SeInput, {
      class: "grow",
      background: "#f3fafa",
      modelValue: _ctx.shopItem.name,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shopItem.name) = $event)),
      value: _ctx.shopItem.getName(),
      placeholderBase: "Nom"
    }, null, 8, ["modelValue", "value"]),
    _createVNode(_component_SeInput, {
      class: "grow",
      background: "#f3fafa",
      modelValue: _ctx.shopItem.description,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shopItem.description) = $event)),
      value: _ctx.shopItem.getDescription(),
      placeholderBase: "Description"
    }, null, 8, ["modelValue", "value"]),
    _createVNode(_component_SeInput, {
      class: "grow",
      numberOnly: true,
      background: "#f3fafa",
      value: _ctx.shopItem.getPrice(),
      modelValue: _ctx.shopItem.price,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shopItem.price) = $event)),
      placeholderBase: "Prix"
    }, null, 8, ["value", "modelValue"])
  ]))
}